import { render, staticRenderFns } from "./MagicPage.vue?vue&type=template&id=383432ce&scoped=true&"
import script from "./MagicPage.vue?vue&type=script&lang=js&"
export * from "./MagicPage.vue?vue&type=script&lang=js&"
import style0 from "./MagicPage.vue?vue&type=style&index=0&id=383432ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383432ce",
  null
  
)

export default component.exports